import currency from 'currency.js'

export const IDR = (value: currency) => currency(value, {symbol: 'Rp ', precision: 2})
